"use strict";

/**
 * Module ConfigurationService
 */
angular.module("services")
    .factory("ConfigurationService", ["$http", "ENV", function ($http, ENV) {

        function getAllConfigurationProperties() {
            return $http.get(ENV.API_URL + "/admin/configuration-properties");
        }

        return {
            getAllConfigurationProperties: getAllConfigurationProperties
        };

    }

    ])
;
